import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-packagesale',
  templateUrl: './packagesale.component.html',
  styleUrls: ['./packagesale.component.css']
})
export class PackagesaleComponent implements OnInit {

  Submitted: boolean = false;
  PackageList: any;
  ParentList: any;
  PackageSaleList:any;
  dropdownSettings: any = {};
  selectedItems: any = [];
  constructor(private subcriptionService: SubscriptionService, private LookupService: LookupService,
     public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


  SaleModel = {
    PackageSaleID:0,
    IsActive: true,
    PackageID: 0,
    PackageSale: '',
    ParentID:0,
    PackageIDs: '',   
    PackageArray: [],

  };

  ClearPackageSale() {
    this.Submitted = false;
    this.SaleModel.PackageSale = '';
    this.SaleModel.PackageID = 0;
    this.SaleModel.PackageSaleID = 0;
    this.SaleModel.ParentID = 0;
    this.SaleModel.PackageIDs='';  
    this.SaleModel.PackageArray= [];
    this.PackageSaleList=[];
  };


  


  PackageSaleMarkActive(obj) {
    this.ClearPackageSale();
    this.SaleModel.PackageSaleID = obj.PackageSaleID;
    this.SaleModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.subcriptionService.SaleMarkActive(JSON.stringify(this.SaleModel)).subscribe((data: any) => {
      this.spinnerService.hide();
      this.GetAllPackageSale();
      this.ClearPackageSale();
      this.globalHelper.CheckActionStatus(data);
    });
  }

 
  SavePackageSale(valid) {
   
    this.Submitted = true;
    if (this.SaleModel.PackageSaleID!=0) {
      this.spinnerService.show();
      this.subcriptionService.SavePackageSale(JSON.stringify(this.SaleModel),JSON.stringify(this.PackageSaleList)).subscribe((data: any) => {
        this.GetAllPackageSale();
        this.spinnerService.hide();

        // this.ClearPackageSale();
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  GetAllPackageSale() {
    if (this.SaleModel.PackageSaleID!=0) {
    this.subcriptionService.GetPackageSale(JSON.stringify(this.SaleModel)).subscribe((data: any) => {
      this.PackageSaleList = data.PackageSaleList;
    
    });
  }

  }
  EditPackageSale(obj) {
   
    this.selectedItems = [];
    this.SaleModel.PackageSaleID = obj.PackageSaleID;
    var PackageIDs = obj.PackageIDs != null ? obj.PackageIDs.split(',') : '';
    for (var i = 0; i < this.PackageList.length; i++) {
      for (var j = 0; j < PackageIDs.length; j++) {
        if (PackageIDs[j] == this.PackageList[i].ItemId) {
          let item = {
            ItemId: this.PackageList[i].ItemId,
            ItemName: this.PackageList[i].ItemName

          }
          this.selectedItems.push(item)
          break;
        }
      }
    }
    this.SaleModel.PackageArray =  this.selectedItems;
    this.SaleModel.PackageSaleID = obj.PackageSaleID;
    this.SaleModel.PackageSale = obj.PackageSale;
    this.SaleModel.ParentID = obj.ParentID;

  };

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ItemId',
      textField: 'ItemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    this.GetAllPackage();
   
    this.GetAllPackageSale();
  }


  GetAllPackage() {

    this.LookupService.GetLookupsList('PackageSale', '').subscribe((data: any) => {
      this.PackageList = data.LookupItems;
    });
  }

 


}

